import { LoanDocState, TaskState } from 'gql/graphql';
import { Phases } from '../../LoanPhase.constanst';

// SVG imports for task icons
import homeWhiteEmptySvg from 'assets/images/home-white-empty.svg';
import homeBlackEmptySvg from 'assets/images/home-black-empty.svg';
import homeGreenSvg from 'assets/images/home-green-all.svg';
import homeErrorEmptySvg from 'assets/images/home-error-empty.svg';
import homeReviewEmptySvg from 'assets/images/home-review-empty.svg';

export const determinePhaseState = (
  _rulesTaskCards: any[],
  loanDocs: any[],
  _phase: any
): { state: string; stateName: string } => {
  
  if (_phase.key === Phases.PRE_APPROVAL) {
    return { state: 'complete', stateName: 'COMPLETE' };
  }

  // Fase sin tasks
  if(_phase.tasksItems?.length === 0) {
    const isCompleted = _phase.lenderTasks?.every((item: any) => item.state === TaskState.Approved);
    
    if (isCompleted) return { state: 'complete', stateName: 'COMPLETE' };
  }

  const loanDocRef = loanDocs?.find(item =>
    item.state === LoanDocState.Blocking &&
    _rulesTaskCards.find(item2 =>
      item2.state !== TaskState.Approved &&
      item2.state !== TaskState.Review &&
      item2.key.includes(item.key)
    )
  );

  const isBlocking = !!loanDocRef;
  const isCompleted = _rulesTaskCards.length > 0 &&
    _rulesTaskCards.every(item => item.state === TaskState.Approved);
  const isProgress = _rulesTaskCards.length > 0 &&
    _rulesTaskCards.find(item => (
      item.state === TaskState.Review || 
      item.state === TaskState.Approved || 
      item.state === TaskState.Incomplete
    ));
  const isError = _rulesTaskCards.find(item => item.state === TaskState.RequestError);

  if (isCompleted) return { state: 'complete', stateName: 'COMPLETE' };
  if (isBlocking) return { state: 'blocked', stateName: 'BLOCKED' };
  if (isProgress) return { state: 'progress', stateName: 'IN PROGRESS' };
  if (isError) return { state: 'error', stateName: 'ERROR' };
  
  return { state: 'not-started', stateName: 'NOT STARTED' };
};

export const getTaskIcon = (taskState: string, phaseState: string): string => {
  if (taskState === TaskState.Approved) return homeGreenSvg;
  if (taskState === TaskState.RequestError) return homeErrorEmptySvg;
  if (taskState === TaskState.Review) return homeReviewEmptySvg;
  return phaseState === 'not-started' ? homeBlackEmptySvg : homeWhiteEmptySvg;
};